export default {
  common: {
    clearAll: 'Tout effacer',
    required: 'Obligatoire',
    restart: 'Redémarrer'
  },
  createUser: {
    acceptTermsAndConditions: 'Accepter les termes et conditions',
    alreadyHaveAccount: 'Vous avez déjà un compte ? %{pre}Télécharger%{post}',
    checkEmail: 'En attendant, téléchargez Metrica Play sur votre ordinateur',
    clubCompany: 'Organisation/Club',
    createdSuccessfully:
      'Inscription réussie ! Consultez votre adresse e-mail enregistrée pour obtenir un lien de vérification. (Vérifiez le dossier spam)',
    email: 'Email',
    invalidEmail: 'E-mail non valide',
    job: 'Emploi/Rôle',
    lastName: 'Nom de famille',
    name: 'Prénom',
    noCustomOption: 'Option non disponible',
    noMatches: 'Aucune correspondance, écrivez votre propre option',
    password: 'Mot de passe',
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    passwordInvalid: 'Le mot de passe ne respecte pas les exigences',
    passwordRequirements: {
      minLength: 'Au moins %{count} caractères',
      uppercase: 'Une lettre majuscule',
      lowercase: 'Une lettre minuscule',
      number: 'Un chiffre (0-9)',
      maxLength: 'Au plus %{count} caractères'
    },
    phone: 'Téléphone',
    phoneCode: 'Pays',
    proceed: 'Continuer',
    repeatPassword: 'Répéter le mot de passe',
    searchPhoneCode: 'Rechercher…',
    seeTermsAndConditions: 'Voir les termes et conditions',
    signAgreement:
      "S'inscrire à un compte Metrica Sports signifie que vous acceptez la %{pre1}Politique de Confidentialité%{post1} et les %{pre2}Conditions de Service%{post2}",
    signUpHere: 'Créez votre compte pour commencer.',
    sport: 'Sport',
    submitting: 'À partir de...',
    title: 'Commencez avec %{product}',
    userKeyField: "Vous avez un code promotionnel ou une clé d'utilisateur ? Remplissez ce champ"
  },
  error: {
    downloadPlay:
      'Si vous avez déjà un compte, téléchargez la dernière version de Play et connectez-vous.',
    emailTaken: 'Cet e-mail a déjà été pris',
    fieldTooLong: 'Certains champs sont trop longs. Raccourcissez-les et réessayez',
    oops: 'Oups!',
    restart:
      "On dirait que vous essayez d'utiliser quelque chose que nous sommes encore en train de développer...",
    tryAgain:
      "Veuillez réessayer. Si cette erreur persiste, contactez l'équipe de support de Metrica Sports",
    userKey:
      "La clé n'est pas valide. Vérifiez votre clé et réessayez ou supprimez le champ pour terminer l'enregistrement"
  },
  invitation: {
    acceptButton: "J'accepte le Changement de Mon Compte",
    accepting: 'Acceptant...',
    cancelButton: 'Refuser',
    description1:
      "Lorsque vous êtes ajouté au nouveau compte Metrica Sports, la propriété de votre compte actuel Metrica Sports (et les informations qu'il contient) sera transférée et attribuée au nouveau propriétaire du compte Metrica Sports. Toutes les informations et données actuellement contenues dans votre compte Metrica Sports, ainsi que toute information ou donnée enregistrée après avoir accepté le changement de compte, seront visibles et disponibles pour le nouveau propriétaire du compte Metrica Sports et tout administrateur(s) de ce compte, pour les utiliser et les partager avec d'autres selon la discrétion du propriétaire du compte.",
    description2:
      'En cliquant sur "J\'accepte le changement de mon compte", vous acceptez et autorisez ce qui suit :',
    list1:
      'Les informations de votre compte actuel seront transférées vers le nouveau compte Metrica Sports.',
    list2:
      'Toutes les informations du compte transférées à votre nouveau compte Metrica Sports depuis votre compte actuel peuvent être gérées par le nouveau propriétaire du compte et/ou administrateur(s).',
    list3:
      "Dans le nouveau compte Metrica Sports, votre rôle sera « Membre ». Vous n'aurez plus de privilèges de propriétaire ou d'administrateur de votre compte actuel.",
    list4:
      'Vous hériterez des paramètres existants de votre nouveau compte Metrica Sports, qui peuvent être plus ou moins restrictifs selon votre rôle dans le compte, et vos paramètres pourront être gérés par le nouveau propriétaire ou administrateur(s) du compte Metrica Sports.',
    list5:
      "Vos paramètres actuels pourront être modifiés s'ils entrent en conflit avec les paramètres du nouveau compte auquel vous vous joignez.",
    list6:
      'Il est possible que votre nouveau compte ne donne pas accès à toutes les fonctionnalités que vous avez dans votre compte actuel.',
    list7:
      "Il n'est pas possible d'annuler le transfert de votre compte une fois que vous l'avez initié, et toutes vos informations de compte resteront dans un seul compte.",
    list8:
      "En cliquant sur « J'accepte le Changement de Mon Compte », vous deviendrez un membre géré du compte de %{pre1}%{email}%{post1} et acceptez les %{pre2}Termes de Service%{post2} et la %{pre3}Déclaration de Confidentialité%{post3} de Metrica Sports.",
    subtitle:
      'En acceptant cette nouvelle invitation de compte Metrica Sports, vous serez ajouté à un autre compte Metrica Sports.',
    title: 'Invitation'
  },
  jobs: {
    academyDirector: "Directeur d'Académie",
    assistantCoach: 'Entraîneur adjoint',
    dataAnalyst: 'Analyste de données',
    doctor: 'Médecin',
    formerPlayer: 'Ancien joueur',
    goalkeeperCoach: 'Entraîneur des gardiens',
    headCoach: 'Entraîneur',
    journalist: 'Journaliste',
    other: 'Autre',
    performance: 'Fitness et performance',
    player: 'Joueur',
    scout: 'Scout',
    sportsDirector: 'Directeur sportif',
    student: 'Etudiant',
    videoAnalyst: 'Analyste vidéo'
  },
  sports: {
    americanFootball: 'Football américain',
    baseball: 'Baseball',
    basketball: 'Basket-ball',
    fieldHockey: 'Hockey sur gazon',
    football: 'Football',
    futsal: 'Futsal',
    gaelicFootball: 'Football gaélique',
    handball: 'Handball',
    iceHockey: 'Hockey sur glace',
    lacrosse: 'Lacrosse',
    netball: 'Netball',
    other: 'Autre',
    padel: 'Padel',
    rugby: 'Rugby',
    tennis: 'Tennis',
    volleyball: 'Volleyball'
  }
}
